import http, { authHeader } from './http';

// Получить опубликованные рекомендации (с учётом подписки)
export const getRecommendations = (token) =>
  http.get('/api/recommendations', { headers: authHeader(token) }).then((r) => r.data);

// --- Admin-функции ---

// Получить все рекомендации (включая черновики)
export const getAllRecommendationsAdmin = (token) =>
  http.get('/api/recommendations/admin', { headers: authHeader(token) }).then((r) => r.data);

// Создать рекомендацию (FormData — поддержка изображений)
export const createRecommendation = (token, formData) =>
  http.post('/api/recommendations/admin', formData, { headers: authHeader(token) }).then((r) => r.data);

// Обновить рекомендацию
export const updateRecommendation = (token, id, formData) =>
  http.put(`/api/recommendations/admin/${id}`, formData, { headers: authHeader(token) }).then((r) => r.data);

// Удалить рекомендацию
export const deleteRecommendation = (token, id) =>
  http.delete(`/api/recommendations/admin/${id}`, { headers: authHeader(token) }).then((r) => r.data);
